import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { DTConfig } from 'src/app/Class/DTConfig ';
import { DataTableDirective } from 'angular-datatables';
import { TramitesService } from 'src/app/servicios/tramites.service';
import { Loading } from 'src/app/Class/Loading';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Mensajes } from 'src/app/Class/mensajes';
declare var $: any;

@Component({
  selector: 'app-tipo-tramites',
  templateUrl: './tipo-tramites.component.html',
  styleUrls: ['./tipo-tramites.component.css']
})
export class TipoTramitesComponent implements OnInit, OnDestroy {

  public dtTrigger: Subject<any> = new Subject();
  public dtOptions: DataTables.Settings = Object.assign({}, DTConfig.dtConf);
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  public tipoTramites: any = [];
  
  public url: string = null;
  index: number;


  constructor( private tipoTramiteService: TramitesService, public loading: Loading) {

    this.loading.estado = true;
    this.url = this.tipoTramiteService.getServe();

    this.tipoTramiteService.getTiposTramites().subscribe( data => {
      this.tipoTramites = data['listado'];
      
      this.dtTrigger.next();
      this.loading.estado = false;
  },
    err => {  this.loading.estado = false; }
  );

   
  }

  ngOnInit() {}

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // NuevoTipoTramite() {
  //   this.formTipoTramite.reset({id: -1});
  //   this.index = null;
  //   $('#ModalTipoTramite').modal({ backdrop: 'static', keyboard: true, show: true });

  // }

  // editar(datos, index) {
  //   this.index = index;
  //                                                                                             // tslint:disable-next-line: forin
  //   for (const atributos in this.formTipoTramite.value) {
  //     this.formTipoTramite.get(atributos).setValue(datos[atributos]);
  //   }
  //   $('#ModalTipoTramite').modal({ backdrop: 'static', keyboard: true, show: true });
  // }

  cambiarEstado(id, index) {
    this.index = index;

    Swal.fire({
    title: Mensajes.cambioestado.titulo,
    text: Mensajes.cambioestado.cuerpo,
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Cambiar',
    reverseButtons: true,
    }).then((result) => {
    if (result.value) {
      this.tipoTramiteService.cambiarEstadoTipoTramite(id).subscribe(data => {
        if ( data ['success']) {
          this.tipoTramites[this.index].estado = data['estado'];
          Swal.fire( Mensajes.cambioestado.respuesta, Mensajes.cambioestado.resultado, 'success' );
          this.rerender();
        } else {
          Swal.fire({ type: 'warning', title: 'No se pudo completar la solicitud', showConfirmButton: false, timer: 1500 });
        }
      });
    }
  });
  }
}
